import React from "react";

export default function Credit() {
  return (
    <div class="credit">
    <p>
      Coded By <span style={{color: "purple", textDecoration:'underline '}}>Shivam Upadhyay</span>.
    </p>
  </div>
  );
}